import React from "react";
import { Route, RouteProps } from "react-router-dom";
import AuthLayout from "layouts/AuthLayout";

interface Props extends RouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children, ...otherProps }: Props) => (
  <Route {...otherProps}>
    <AuthLayout>{children}</AuthLayout>
  </Route>
);

export default ProtectedRoute;
